import {extend} from "../../utils/utils";
import {DataMode} from "../../const";


const initialState = {
  activePeriodId: ``,
  activeDataMode: DataMode.FISH,
  activePoolId: null,
  activeAreaId: null,
  isLabelLoad: false,
};

const ActionType = {
  SET_ACTIVE_PERIOD: `SET_ACTIVE_PERIOD`,
  CHANGE_ACTIVE_DATA_MODE: `CHANGE_ACTIVE_DATA_MODE`,
  SET_ACTIVE_POOL_ID: `SET_ACTIVE_POOL_ID`,
  SET_ACTIVE_AREA_ID: `SET_ACTIVE_AREA_ID`,
  SET_IS_LABEL_LOAD: `SET_IS_LABEL_LOAD`,
};

const ActionCreator = {
  setActivePeriod: (period) => ({
    type: ActionType.SET_ACTIVE_PERIOD,
    payload: period,
  }),
  changeActiveDataMode: (dataMode) => ({
    type: ActionType.CHANGE_ACTIVE_DATA_MODE,
    payload: dataMode,
  }),
  setActivePoolId: (poolId) => ({
    type: ActionType.SET_ACTIVE_POOL_ID,
    payload: poolId,
  }),
  setActiveAreaId: (areaId) => ({
    type: ActionType.SET_ACTIVE_AREA_ID,
    payload: areaId,
  }),
  setIsLabelLoad: (value) => ({
    type: ActionType.SET_IS_LABEL_LOAD,
    payload: value,
  }),
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.SET_ACTIVE_PERIOD:
      if (action.payload === state.activePeriodId) {
        return state;
      } else {
        return extend(state, {
          activePeriodId: action.payload,
        });
      }

    case ActionType.CHANGE_ACTIVE_DATA_MODE:
      if (action.payload === state.activeDataMode) {
        return state;
      } else {
        return extend(state, {
          activeDataMode: action.payload,
        });
      }

    case ActionType.SET_ACTIVE_POOL_ID:
      return extend(state, {
        activePoolId: action.payload,
      });

    case ActionType.SET_ACTIVE_AREA_ID:
      return extend(state, {
        activeAreaId: action.payload,
      });

    case ActionType.SET_IS_LABEL_LOAD:
      return extend(state, {
        isLabelLoad: action.payload,
      });

    default:
      return state;
  }
};


export {
  ActionCreator,
  ActionType,
  reducer,
};
